import { render } from "./InsuredAllDialog.vue?vue&type=template&id=91276778&scoped=true"
import script from "./InsuredAllDialog.vue?vue&type=script&lang=js"
export * from "./InsuredAllDialog.vue?vue&type=script&lang=js"

import "./InsuredAllDialog.vue?vue&type=style&index=0&id=91276778&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Rufiz Huseynzada\\OneDrive - Azerbaijan State Oil and Industry University\\Desktop\\ProgressProjects\\Account\\web\\Medical-Account-Web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91276778"]])

export default __exports__